import { type SagaIterator } from 'redux-saga';
import { all, fork } from 'redux-saga/effects';

import { fetchBillingInfoSaga } from './fetch-billing-info';
import { saveCreditCardSaga } from './save-credit-card';

export function* billingSagas(): SagaIterator {
  yield all([fork(fetchBillingInfoSaga), fork(saveCreditCardSaga)]);
}
